import { useState } from 'react'
import { CSVBoxButton } from '@csvbox/react'

import { Button, LoadingSpinner } from '@atoms'
import { type CsvBoxColumn, type CsvBoxEnvironment } from '@utils/imports/types'
import { scopedTranslation } from '@utils/I18n'

const tShared = scopedTranslation('shared')

export type SupporterImportCsvBoxProps = {
  requestingUserId: number
  importToken: string
  licenseKey: string
  environment: CsvBoxEnvironment
  columns: CsvBoxColumn[]
  onImport: (isSuccessful: boolean) => void
}

export const SupporterImportCsvBox = ({
  requestingUserId,
  importToken,
  licenseKey,
  environment,
  columns,
  onImport,
}: SupporterImportCsvBoxProps) => {
  const [loading, setLoading] = useState(true)

  return (
    <CSVBoxButton
      licenseKey={licenseKey}
      environment={environment}
      user={{ user_id: requestingUserId, import_token: importToken }}
      onImport={onImport}
      onReady={() => setLoading(false)}
      dynamicColumns={columns}
      render={(launch) =>
        loading ? (
          <Button type="button" size="xl" disabled>
            <LoadingSpinner size="sm" />
            {tShared('labels.loading')}
          </Button>
        ) : (
          <Button type="button" size="xl" leadingIcon="plus-circle" onClick={launch}>
            {tShared('labels.choose_file')}
          </Button>
        )
      }
    />
  )
}
